module.exports = __webpack_public_path__ + "img/The-Wasp-bg.e5226620.png";